import Button_module_default from "./Button.module.js";
import { UnstyledButton } from "./UnstyledButton.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Button/Button.tsx
/**
* A button component that can be transformed into a link, but keep the button
* styling using the `as` property.
*/
var Button = forwardRef(function Button({ as, kind: kindProp = "primary", size = "lg", children, className, iconOnly, Icon, destructive: destructiveProp, disabled, ...props }, ref) {
	const [kind, destructive] = kindProp === "destructive" ? ["secondary", true] : [kindProp, destructiveProp];
	const classes = classNames(Button_module_default.button, className, {
		[Button_module_default["has-icon"]]: Icon,
		[Button_module_default["icon-only"]]: iconOnly,
		[Button_module_default.destructive]: destructive
	});
	const iconSize = iconOnly && size === "lg" ? 24 : 20;
	return /* @__PURE__ */ jsxs(UnstyledButton, {
		...props,
		as: as || "button",
		ref,
		className: classes,
		"data-size": size,
		"data-kind": kind,
		tabIndex: 0,
		disabled,
		children: [Icon && /* @__PURE__ */ jsx(Icon, {
			width: iconSize,
			height: iconSize,
			className: Button_module_default.icon,
			"aria-hidden": true
		}), children]
	});
});
//#endregion
export { Button };

//# sourceMappingURL=Button.js.map